import { DepartmentStateTypes, DepartmentActionTypes } from "./Department.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: DepartmentStateTypes = {
  fetchAll: resetApiCallState([]),
};

const DepartmentReducer = (
  state: DepartmentStateTypes = INITIAL_STATE,
  action: any
): DepartmentStateTypes => {
  switch (action.type) {
    case DepartmentActionTypes.FETCH_ALL_DEPARTMENT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case DepartmentActionTypes.FETCH_ALL_DEPARTMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case DepartmentActionTypes.FETCH_ALL_DEPARTMENT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case DepartmentActionTypes.FETCH_ALL_DEPARTMENT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default DepartmentReducer;
